export default __webpack_public_path__ + "static/media/star.8947fe3e.svg";